export const invoice = (invoice) => {
    const errors = {}
    let isValid = true
    if(!invoice.invoice_number) {
        isValid = false
        errors.invoice_number = 'required'
    }
    if(!invoice.customer_id) {
        isValid = false
        errors.customer_id = 'required'
    }
    if(!invoice.delivery_date || !invoice.datePickerOpened.delivery_date) {
        isValid = false
        errors.delivery_date = 'required'
    }
    if(!invoice.issue_date || !invoice.datePickerOpened.issue_date) {
        isValid = false
        errors.issue_date = 'required'
    }
    if(!invoice.due_date || !invoice.datePickerOpened.due_date) {
        isValid = false
        errors.due_date = 'required'
    }
    if(!invoice.order_date || !invoice.datePickerOpened.order_date) {
        isValid = false
        errors.order_date = 'required'
    }
    if(invoice.payment_reference && invoice.payment_reference.length > 20) {
        isValid = false
        errors.payment_reference = 'Max length is 20 chars'
    }
    let articles = invoice.invoice_articles
    errors.articles = []
    if(invoice.invoice_articles.length === 0) {
        errors.no_line = 'Add at least one line'
    }
    articles.forEach(({article_number, article_description, quantity, price_per_unit, unit,price_reduction, price_discount, vat_rate, total_vat_amount, total_price_including_vat}, index) => {
        let articleErrors = {}
        if(!article_number) {
            isValid = false
            articleErrors.article_number = 'required'
        }
        if(!article_description) {
            isValid = false
            articleErrors.article_description = 'required'
        }
        if(!vat_rate) {
            isValid = false
            articleErrors.vat_rate = 'required'
        }
        if(!quantity) {
            isValid = false
            articleErrors.quantity = 'required'
        }
        if(!price_per_unit) {
            isValid = false
            articleErrors.price_per_unit = 'required'
        }
        if(!total_vat_amount) {
            isValid = false
            articleErrors.total_vat_amount = 'required'
        }
        if(!total_price_including_vat) {
            isValid = false
            articleErrors.total_price_including_vat = 'required'
        }
        if(!unit) {
            isValid = false
            articleErrors.unit = 'required'
        }
        if(!price_discount) {
            isValid = false
            articleErrors.price_discount = 'required'
        }
        if(!price_reduction) {
            isValid = false
            articleErrors.price_reduction = 'required'
        }
        errors.articles.push(articleErrors)
    })
    return {isValid, errors}
}
